import React from 'react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-16 bg-[#e3e4e6]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Client Logos */}
        <div>
          <p className="text-center text-[#c3c3c5] text-sm mb-8">Empresas que confían en nosotros</p>
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-16">
            <img 
              src="https://customer-assets.emergentagent.com/job_asisant-portal/artifacts/3dvmgdjc_logo-nos.svg" 
              alt="NOS" 
              className="h-10 opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_asisant-portal/artifacts/7v6ck0rn_Telia_logo_2022.svg" 
              alt="Telia" 
              className="h-10 opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cloudsmart/artifacts/0fkdcxga_Cynersis-Logo-Azul-y-Color.webp" 
              alt="Cynersis" 
              className="h-10 opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cloudsmart/artifacts/k5sdlyl5_Warpcom-Logo-Cores.webp" 
              alt="Warpcom" 
              className="h-10 opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cloudsmart/artifacts/icrotpan_G_Logo_Identificador_Verde.png" 
              alt="Gibraltar" 
              className="h-10 opacity-70 hover:opacity-100 transition-opacity cursor-pointer"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
